import TicketHttp from "../../ticketHttp";

class MovieServices {
  // static async getMovies(){
  //     return TicketHttp.get('/movies');
  // }


  static async getMovies(theatreName = '') {
      const query = theatreName ? `?theatreName=${encodeURIComponent(theatreName)}` : '';

      return TicketHttp.get(`/movies${query}`);
    }



// movieServices.js
static async getMoviesForReport({ theatreName = '', includeArchived = false }) {
  const params = new URLSearchParams();

  if (theatreName) {
    params.append("theatreName", theatreName); // can be ID or name
  }
  params.append("includeArchived", includeArchived );

  return TicketHttp.get(`/movies/getMoviesForReport?${params.toString()}`);
}







  // static async getTheatersAndShowTimings(id,theatreName, formattedDate){

  //     // const query = theatreName ? `?theatreName=${encodeURIComponent(theatreName)}` : "";
  //     // return TicketHttp.get(`/theatres/getTheatersAndShowTimings/${id}${query}`);







  //     const params = [];

  //     if (formattedDate) params.push(`date=${formattedDate}`);
  //     if (theatreName) params.push(`theatreName=${encodeURIComponent(theatreName)}`);

  //     const query = params.length > 0 ? `?${params.join('&')}` : '';

  //     console.log('query====================', query);

  //     return TicketHttp.get(`/theatres/getTheatersAndShowTimings/${id}${query}`);


  //     // return TicketHttp.get(`/theatres/${id}`);
  // }










  static async getTheatersAndShowTimings(id, theatreName, formattedDate, isAdmin) {
    const params = [];

    if (formattedDate) params.push(`date=${formattedDate}`);
    if (theatreName) params.push(`theatreName=${encodeURIComponent(theatreName)}`);
    if (isAdmin) params.push(`isAdmin=true`); // ✅ Add the isAdmin parameter

    const query = params.length > 0 ? `?${params.join('&')}` : '';

    return TicketHttp.get(`/theatres/getTheatersAndShowTimings/${id}${query}`);
  }





  // static async getDriverTripcount(id){
  //     return Http.get(`/rider-trip-counts/${id}`);
  // }
  static async updateMovies(id, data) {
    console.log("========================================data in the riderServices", data)
    return TicketHttp.update(`/riders/${id}`, data)
  }
  static async addMovie(data) {
    return TicketHttp.post("/movies/", data);
  }
  static async getDriverEarnings(id) {
    return TicketHttp.get(`/rider-earnings/${id}`);


  }


  static async getMovieByTheaterId(theatreId) {
    return TicketHttp.get(`/movies/getMovieByTheaterId/${theatreId}`);


  }



  static async getDriverEarnings(id) {
    return TicketHttp.get(`/rider-earnings/${id}`);


  }

  static async updateMovie(id, data) {
    return TicketHttp.update(`/movies/movie/${id}`, data);


  }

  static async deleteMovie(id) {
    return TicketHttp.delete(`/movies/movie/${id}`);


  }

  static async getMoviesReadyToBook(theatreName = '') {
    const query = theatreName ? `?theatreName=${encodeURIComponent(theatreName)}` : '';
    return TicketHttp.get(`/movies/getMoviesReadyToBook${query}`);
  }

  static async getMoviesArchReady(theatreName = '') {
    const query = theatreName ? `?theatreName=${encodeURIComponent(theatreName)}` : '';
    return TicketHttp.get(`/movies/getMoviesArchReady${query}`);
  }
  static async getMoviesForShowPerformance(theatreName = '') {
    const query = theatreName ? `?theatreName=${encodeURIComponent(theatreName)}` : '';
    return TicketHttp.get(`/movies/getMoviesForShowPerformance${query}`);
  }

  static async getAllMovies(theatreName = '') {
    const query = theatreName ? `?theatreName=${encodeURIComponent(theatreName)}` : '';
    return TicketHttp.get(`/movies/getAllMovies/${query}`);
  }


  static async getAllMoviesWithSchedules(theatreName = '') {
    const query = theatreName ? `?theatreName=${encodeURIComponent(theatreName)}` : '';
    return TicketHttp.get(`/movies/getAllMoviesWithSchedules/${query}`);
  }




  
  // static async getIMDB(data) {
  
    

  //   return TicketHttp.post('/movieMeta/fetchStore', data);
  // }


  // static async getIMDB(name, options = {}) {
  //   const value = typeof name === "string" ? name : name?.name;
  //   if (!value?.trim()) throw new Error("name is required");
  //   return TicketHttp.post(
  //     "/movieMeta/fetchStore",   // make sure this matches your server route
  //     { name: value.trim() },
  //     options
  //   );
  // }


  // static async searchIMDB(name, options = {}) {
  //   const value = typeof name === "string" ? name : name?.name;
  //   if (!value?.trim()) throw new Error("name is required");
  //   return TicketHttp.post(
  //     "/movieMeta/fetchStore",   // make sure this matches your server route
  //     { name: value.trim() },
  //     options
  //   );
  // }












  static async fetchAndStoreByImdbId(imdbId, options = {}) {
    console.log('calling serever', imdbId);
    // const id = typeof imdbId === "string" ? imdbId : imdbId;

    // console.log('id',id);
    // if (!id?.trim()) throw new Error("imdbId is required");

    // console.log('id.trim()',id.trim());
    return TicketHttp.post("/movieMeta/fetchStore", { tmdbId: imdbId }, options);
  }

  // Search minimal list (NO SAVE)
  // static async searchMovie(q, { year, page = 1, region, limit, signal } = {}) {
  //   const query = typeof q === "string" ? q : q?.name || q?.q;
  //   if (!query?.trim()) throw new Error("q is required");
  //   return TicketHttp.get("movieMeta/searchMovie", {
  //     params: { q: query.trim(), year, page, region, limit },
  //     signal,
  //   });
  // }




  // static async searchMovie(q, { year, page = 1, region, limit = 20 } = {}) {
  //   const query = typeof q === "string" ? q : q?.name || q?.q;
  //   if (!query?.trim()) throw new Error("q is required");
  
  //   return TicketHttp.get("/api/movieMeta/searchMovie", {
  //     params: {
  //       q: query.trim(),
  //       ...(year ? { year } : {}),
  //       ...(region ? { region } : {}),
  //       page,
  //       limit,
  //     },
  //   });
  // }


  // static async searchMovie(input) {


  //   console.log('input in the searchMovie', input, typeof input)
  //   const name = typeof input === "string" ? input : input?.name;
  //   if (!name?.trim()) throw new Error("name is required");

  //   console.log('name', name.trim())
  //   // NOTE: use the right prefix based on your baseURL
  //   return TicketHttp.get("/movieMeta/searchMovie", {
  //     params: { name: name.trim() },
  //   });


    
  // }

  static async searchMovie(input, { year, page = 1, region, limit = 20 } = {}) {
  console.log('input in the searchMovie', input, typeof input);

  const name = typeof input === 'string' ? input : input?.name;
  if (!name?.trim()) throw new Error('name is required');

  console.log('name', name.trim());

  return TicketHttp.post('/movieMeta/searchMovie', {
    q: name.trim(),
    year,
    region,
    page,
    limit,
  });
  

  // return TicketHttp.get('/movieMeta/searchMovie', {
  //   params: {
  //     q: name.trim(),
  //     ...(year ? { year } : {}),
  //     ...(region ? { region } : {}),
  //     page,
  //     limit,
  //   },
  // });
}






  



  static async saveMovie(movieData, options = {}) {
    // movieData should include at least { name: string, tmdbData: object }
    if (!movieData?.name?.trim()) throw new Error("name is required");
    if (!movieData?.tmdbData) throw new Error("tmdbData is required");
  
    return TicketHttp.post(
      "/movieMeta/saveMovie",  // backend route for saving confirmed movie
      {
        name: movieData.name.trim(),
        tmdbData: movieData.tmdbData,
      },
      options
    );
  }
  




}
export default MovieServices